import { Card } from '../components/Card';

export function Terms() {
  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="mb-8 text-2xl font-bold text-white">Terms of Service</h1>
      <Card>
        <div className="prose-legal space-y-6 text-sm leading-relaxed text-iron-300">
          <p className="text-xs text-iron-500">Effective 14 April 2026 &middot; Version 1.0</p>

          <section>
            <h2>1. Acceptance</h2>
            <p>By using GG Anvil you agree to these Terms and our <a href="/privacy" className="text-forge-400 hover:text-forge-300">Privacy Policy</a>.</p>
          </section>

          <section>
            <h2>2. Eligibility</h2>
            <p>Must be 13+, have a Discord account, provide accurate info. One account per person.</p>
          </section>

          <section>
            <h2>3. Your Account</h2>
            <p>Linked to your Discord. You are responsible for all activity under your account. Do not share your portal link.</p>
          </section>

          <section>
            <h2>4. Acceptable Use</h2>
            <p>No falsified screenshots, impersonation, automated abuse, harassment, unauthorised access, score manipulation, or unlawful use.</p>
          </section>

          <section>
            <h2>5. Content</h2>
            <p>Match screenshots are licensed to GG Anvil for processing and verification. You retain ownership. Results and standings are platform data. False evidence may result in sanctions.</p>
          </section>

          <section>
            <h2>6. Billing</h2>
            <p>Payments via Stripe/Paystack. Non-refundable unless stated. Pricing changes with 30 days notice.</p>
          </section>

          <section>
            <h2>7. Availability</h2>
            <p>Provided "as is". No guarantee of uptime. We may modify or discontinue features.</p>
          </section>

          <section>
            <h2>8. Disputes</h2>
            <p>Match disputes via the built-in system. Platform disputes: informal resolution first, then mediation. Governed by South African law.</p>
          </section>

          <section>
            <h2>9. Liability</h2>
            <p>Not liable for indirect damages. Total liability capped at fees paid in prior 12 months.</p>
          </section>

          <section>
            <h2>10. Termination</h2>
            <p>You may stop at any time and request data deletion. We may suspend for violations.</p>
          </section>

          <p className="pt-4 text-xs text-iron-500">
            Full terms: <a href="https://goodgameanvil.com/terms" target="_blank" rel="noopener noreferrer" className="text-forge-400 hover:text-forge-300">goodgameanvil.com/terms</a>
          </p>
        </div>
      </Card>

      <style>{`
        .prose-legal h2 { font-size: 0.875rem; font-weight: 700; color: white; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.5rem; }
        .prose-legal section { border-bottom: 1px solid rgba(255,255,255,0.05); padding-bottom: 1.25rem; }
        .prose-legal section:last-of-type { border-bottom: none; }
        .prose-legal p { margin-bottom: 0.5rem; }
      `}</style>
    </div>
  );
}
